<template>
  <teleport to="body">
    <div @click="dialogVisible = false" class="dialog-box" v-if="dialogVisible">
      <div @click.stop="" class="dialog-contnet">
        <h2>{{ $t("home.text48") }}</h2>

        <ul>
          <li>
            <el-icon size="12px" color="#9038FF"><CircleCheckFilled /></el-icon>
            <span>{{ $t("home.text49") }}</span>
          </li>
          <li>
            <el-icon size="12px" color="#9038FF"><CircleCheckFilled /></el-icon>
            <span>{{ $t("home.text50") }}</span>
          </li>
          <li>
            <el-icon size="12px" color="#9038FF"><CircleCheckFilled /></el-icon>
            <span>{{ $t("home.text51") }}</span>
          </li>
        </ul>

        <div class="info">
          <img :src="contactUrl" alt="" />
          <p>{{ $t("home.text52") }}</p>
        </div>

        <div @click.stop="dialogVisible = false" class="button">
          {{ $t("home.text53") }}
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { CircleCheckFilled } from "@element-plus/icons-vue";
import { useGetLanguage } from "@/hooks/useGetLanguage";

const dialogVisible = defineModel();

const { contactUrl } = useGetLanguage();

function preventScroll(e: any) {
  e.preventDefault();
  e.stopPropagation();
  return false;
}

watch(
  dialogVisible,
  (val) => {
    if (val) {
      document.addEventListener("wheel", preventScroll, { passive: false });
    } else {
      document.removeEventListener("wheel", preventScroll);
    }
  },
  {
    immediate: true,
  }
);
</script>

<style scoped lang="scss">
.dialog-box {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .dialog-contnet {
    width: 532px;
    background-color: #fff;
    border-radius: 16px 16px 16px 16px;
    padding: 36px;

    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #1d212d;
      text-align: center;
    }

    ul {
      margin: auto;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #9038ff;
      margin-top: 40px;
      margin-bottom: 24px;
      width: max-content;
      span {
        margin-left: 6px;
      }
    }

    .info {
      margin: auto;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #667085;
      img {
        width: 160px;
        height: 160px;
      }
    }

    .button {
      width: 100%;
      height: 44px;
      border-radius: 12px 12px 12px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      background-color: #9038ff;
      opacity: 0.7;
      transition: all 0.3s;
      cursor: pointer;
      margin-top: 40px;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
